import React, { useMemo, useState } from 'react';
import classNames from 'classnames';
import SegmentCo from '../SegmentCo';
import { useIntl } from 'umi';
import { LANGUAGE_EN } from '@home/_config/config';
import { getName } from '@home/utils/common';
import { Radio } from 'tea-component';
import './index.scss';

const SalesBreakdownTab = (props: any) => {
  const {
    className,
    style,
    segmentConfig,
    radioConfig,
    children,
    data,
    ...restProps
  } = props;
  const { locale } = useIntl();
  const isEn = locale === LANGUAGE_EN;
  const { options, dataKey } = radioConfig || {};

  const [radioValue, setRadioValue] = useState<string>(
    radioConfig?.options?.[0]?.value || '',
  );

  const radioOptions = useMemo(
    () =>
      options?.map((item: any) => {
        const { nameEn, nameCn, value } = item || {};
        const name = getName(isEn, nameEn, nameCn);
        return {
          name,
          value,
        };
      }) || [],
    [isEn, options],
  );

  const changeRadio = (value: string) => {
    setRadioValue(value);
    props?.changeData?.(dataKey, value);
  };

  const changeSegment = (key: string, value: string) => {
    props?.changeData?.(key, value);
  };

  return (
    <div
      className={classNames('dbd-sales-breakdown-tab-container', className)}
      style={style}
    >
      <div className="dbd-sales-breakdown-tab">
        {segmentConfig && (
          <SegmentCo
            config={segmentConfig}
            data={data}
            changeData={changeSegment}
          ></SegmentCo>
        )}
        {radioConfig && (
          <Radio.Group value={radioValue} onChange={changeRadio}>
            {radioOptions?.map((item) => (
              <Radio key={item?.value} name={item?.value}>
                {item?.name}
              </Radio>
            ))}
          </Radio.Group>
        )}
      </div>
      {React.Children.map(children, (child: any) =>
        React.cloneElement(child, {
          ...restProps,
        }),
      )}
    </div>
  );
};

export default SalesBreakdownTab;
